// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput__wrapper___1P8oT","input":"SearchInput__input___mWqyw"};